import { Component, OnInit, ViewChild } from '@angular/core';
import { ContactMsg } from '../../core/models/contact';
import { ContactService } from '../../core/services/contact.service';

import { NgForm } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent  extends BaseComponent implements OnInit {
  @ViewChild('CourseForm', { static: false }) CourseForm: NgForm;

  contactMsg = {} as ContactMsg;

  loading = false;

  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private contactService: ContactService,
  ) {  super() }

  ngOnInit(): void {
  }

  sendMsg() {
    var lang = localStorage.getItem('lang');
    this.contactMsg.lang = lang
    this.loading = true;
    this.contactService.Send(this.contactMsg).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        if (data.result.message.type === 'Success') {
          this.loading = false;
          this.alertService.success(this.translate.instant('msgSent'));
          this.contactMsg = {} as ContactMsg;
        }
        else {
          this.loading = false;
        }
        
      }
    )
  }

}
